import store from '@/store'
import { validateLogin, getDefaultPage, rolePermission } from '@/constants/global/user'
import { addToast } from '@/constants/global/toast'

export const checkUser = async (to, isRouter = true) => {
  let user = store.state.user.user || (await validateLogin())
  if (
    (to.meta.login && !user) ||
    ((to.meta.login === false) && user) ||
    (to.meta.roles && !rolePermission(to.meta.roles))
  ) {
    isRouter && addToast('error', user ? 'No Permission' : 'Please Login')
    return { name: getDefaultPage(user) }
  }
}
